export const GOOGLE_TRANSLATE_RESTRICTED_API_KEY = 'AIzaSyD45LavTx1CyOlRXgqKsI22-fSM9qnBP60'
export const TRANSLATE_ENDPOINT = 'https://translation-worker-topcoder.hannan.workers.dev/'